module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_SLD2_16"],"polygon":[{"$":{"points":"16 2 14 2 14 0 13 0 13 2 12 2 12 6 13 6 13 13 11 13 11 11 9 11 9 2 3 2 3 0 2 0 2 2 2 3 2 7 1 7 1 11 2 11 2 16 3 16 3 11 5 11 5 7 3 7 3 3 8 3 8 11 7 11 7 15 11 15 11 14 13 14 13 16 14 16 14 14 14 13 14 6 16 6 16 2","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_SLD2_16.svg
// module id = P0ug
// module chunks = 1